

import {EPartialInfoPool,SendersFactory,TPromisePool, TPromisePoolPartialSender, TPromisePoolPartialTemplates, TSystemEmail, TemplatesFactory,startPromisePool } from "cakemail-ui-components-v2"

export async function systemEmailTemplatesPromissePool({ data, setter, ...rest }: TPromisePool<TSystemEmail, TPromisePoolPartialTemplates>) {
    return startPromisePool({
        ...rest,
        data: data.filter((s) => s.template?.id),
        setter,
        dataIdPath: "template.id",
        storageKey: EPartialInfoPool.partialTemplates,
        processor: ({ processSetter, item }) => {
            return TemplatesFactory.get({ id: Number(item.template?.id) })
                .then((data) => {
                    const partialResults = {
                        name: data.name,
                        description: data.description,
                        thumbnail_url: data.thumbnail_url
                    }
                    processSetter(partialResults)
                    return partialResults
                })
                .catch(() => { return undefined })
        }
    })
}

export async function systemEmailSenderPromissePool({ data, setter, ...rest }: TPromisePool<TSystemEmail, TPromisePoolPartialSender>) {
    return startPromisePool({
        ...rest,
        data: data.filter((s) => s.sender?.id),
        setter,
        dataIdPath: "sender.id",
        storageKey: EPartialInfoPool.partialSenders,
        processor: ({ processSetter, item }) => {
            return SendersFactory.get({ id: Number(item.sender?.id) })
                .then((data) => {
                    const partialResults = {
                        email: data.email,
                        name: data.name,
                        confirmed: data.confirmed
                    }
                    processSetter(partialResults)
                    return partialResults
                })
                .catch(() => { return undefined })
        }
    })
}